import { API_ROOT } from '../../config/config'
import {
  doDelete,
  doDownload,
  doGet,
  doPost,
  doPostDownload,
  doPostFiles,
  doDeleteBody,
} from './utils'

// const API_ROOT = 'http://localhost:80/api'

export const getDocumentManageIa = () => {
  const url = `${API_ROOT}/v1/audit/ia/document-management/page`
  return doGet(url)
}

export const searchDocumentManageIa = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/document-management`
  return doPost(url, request)
}

export const saveDocumentManageIa = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/document-management/save`
  return doPostFiles(url, request)
}

export const downloadDocumentManageIaFile = (filePath) => {
  const url = `${API_ROOT}/v1/audit/download/file?filePath=${filePath}`
  return doDownload(url)
}

export const deleteDocumentManageIaFile = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/document-management/delete`
  return doDeleteBody(url, request)
}

export const getEmailAttchMange = () => {
  const url = `${API_ROOT}/v1/audit/ia/email-attch-management/page`
  return doGet(url)
}

export const saveEmailAttchMange = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/email-attch-management/save`
  return doPostFiles(url, request)
}

export const saveLinkEmailAttchMange = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/linked-attch-management/save`
  return doPostFiles(url, request)
}

export const deleteIaFileMin = (request) => {
  const url = `${API_ROOT}/v1/audit/ia/linked-attch-management/delete`
  // return doPost(url, request)
  return doDeleteBody(url, request)
}
